import { Commentary as CommentaryComponent } from './Commentary.component';
import { connector } from './Commentary.connector';

export const Commentary = connector(CommentaryComponent);
